import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MESSAGE_COMPOSER';

export const {
    action: sendNew,
    success: sendNewSuccess,
    failed: sendNewFailed,
} = createAction(`${domain}/SEND_NEW`, (body, participants, imageIds, fileIds, shouldArchive, sendAsSms) => ({
    body,
    participants,
    imageIds,
    fileIds,
    shouldArchive,
    sendAsSms,
}));

export const {
    action: reply,
    success: replySuccess,
    failed: replyFailed,
} = createAction(
    `${domain}/REPLY`,
    (body, conversationId, imageIds, fileIds, shouldArchive, sendAsSms) => ({
        body,
        conversationId,
        imageIds,
        fileIds,
        shouldArchive,
        sendAsSms,
    }),
    (newMessage, conversationId) => ({newMessage, conversationId}),
);

export const {action: draftMessage} = createAction(`${domain}/DRAFT_MESSAGE`, () => ({}));
